import { createIntersectionObserver } from "@faire/web/ui/hooks/IntersectionObserverFactory";
import React, { createContext, useContext, useMemo } from "react";

interface UnmountContextValue {
  onUnmount?: (brandToken: string, impressionId: string) => void;
}

const UnmountContext = createContext<UnmountContextValue>({});

export const UnmountProvider: React.FC<
  UnmountContextValue & { children: React.ReactNode }
> = ({ onUnmount, children }) => {
  const value = useMemo(() => ({ onUnmount }), [onUnmount]);
  return (
    <UnmountContext.Provider value={value}>{children}</UnmountContext.Provider>
  );
};

export const useUnmountBrandTileContext = (): UnmountContextValue => {
  return useContext(UnmountContext);
};

const { IntersectionObserverProvider, usePairedIntersectionObserver } =
  createIntersectionObserver();

export { IntersectionObserverProvider, usePairedIntersectionObserver };

interface ClickContextValue {
  onLeftClick?: (args: { brandToken: string; impressionId: string }) => void;
  onMiddleClick?: (args: { brandToken: string; impressionId: string }) => void;
  onRightClick?: (args: { brandToken: string; impressionId: string }) => void;
}

export const ClickContext = createContext<ClickContextValue>({});
